import { render } from "./ReportInsertInput.vue?vue&type=template&id=10c2bd11"
import script from "./ReportInsertInput.vue?vue&type=script&lang=js"
export * from "./ReportInsertInput.vue?vue&type=script&lang=js"

import "./ReportInsertInput.vue?vue&type=style&index=0&id=10c2bd11&lang=css"

import exportComponent from "C:\\Users\\Pablo Sastre\\OneDrive\\Escritorio\\BAIPManagerTestv2\\BaipMarket.Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__